/**
 * PublicationGroup
 */
import React from 'react';
/** Publication list group. */
var PublicationGroup = function (_a) {
    var heading = _a.heading, children = _a.children;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "aria-live": "polite", "data-cid": "PublicationGroup", className: "bg-greyLight border-t-2 border-greyLight" }, heading && React.createElement("h2", { className: "text-p font-normal px-1" }, heading)),
        children));
};
export default PublicationGroup;
